<template>
    <div class="detail-maxbox">
        <!-- 搜索区域 -->
        <div class="search-header">
            <div class="title-row">
                <i class="el-icon-menu"></i>
                <span class="page-title">海外仓派送查询</span>
            </div>
            <div class="search-row">
                <el-input v-model="search" class="search-input" placeholder="请输入客户编号/订单编号"></el-input>
                <el-button class="searchBtn" type="success" @click="doSearch">查询</el-button>
            </div>
        </div>

        <!-- 收件人信息 -->
        <div class="info-card" v-if="outData">
            <div class="info-grid">
                <div class="info-item">
                    <span class="info-label">Consignee</span>
                    <span class="info-value">{{ outData.consignee_title }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">Address</span>
                    <span class="info-value">{{ outData.address }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">Consignee person</span>
                    <span class="info-value">{{ outData.consignee }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">Email</span>
                    <span class="info-value">{{ outData.email }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">Deliveries number</span>
                    <span class="info-value">{{ outData.entrust_quantity }} PCS</span>
                </div>
            </div>
        </div>

        <!-- 追踪信息列表 -->
        <div class="tracking-section" v-if="trackingData && trackingData.length" v-loading="loading">
            <div class="tracking-card" v-for="item in trackingData" :key="item.id">
                <div class="tracking-header">
                    <div class="tracking-title">
                        <i class="el-icon-document"></i>
                        <span>Process</span>
                        <span class="tracking-no">{{ item.tracking_no }}</span>
                        <el-tag :type="item.is_delivered ? 'success' : 'warning'" size="small" class="status-tag">
                            {{ item.is_delivered ? 'DELIVERED' : 'IN TRANSIT' }}
                        </el-tag>
                    </div>
                </div>
                <div class="process-table">
                    <div class="process-header">
                        <span class="col-time">| Time</span>
                        <span class="col-desc">| Description</span>
                        <span class="col-warehouse">| Warehouse</span>
                    </div>
                    <div class="process-list">
                        <div class="process-item" v-for="node in getSortedNodes(item.node_list)" :key="node.id">
                            <div class="col-time">{{ node.node_time | secondFormat() }}</div>
                            <div class="col-desc">
                                <span class="desc-zh">【{{ node.desc_zh }}】</span>
                                <span class="desc-en">{{ node.desc_en }}</span>
                                <a v-if="node.file_url" :href="node.file_url" target="_blank" class="download-icon">
                                    <i class="el-icon-download"></i>
                                </a>
                            </div>
                            <div class="col-warehouse">{{ node.place }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 空状态 -->
        <div class="empty-state" v-if="!loading && searched && (!trackingData || !trackingData.length)">
            <el-empty description="暂无追踪数据"></el-empty>
        </div>

        <!-- 加载状态 -->
        <div class="loading-state" v-if="loading" v-loading="loading" style="min-height: 200px;"></div>
    </div>
</template>

<script>
export default {
    name: "zylTracking",
    data() {
        return {
            search: '',
            loading: false,
            searched: false,
            outData: null,
            trackingData: []
        }
    },
    mounted() {
        // 如果 URL 带有 search 参数，自动查询
        if (this.$route.query.search) {
            this.search = this.$route.query.search
            this.fetchTracking()
        }
    },
    methods: {
        doSearch() {
            if (!this.search) {
                this.$message.warning('请输入查询单号')
                return
            }
            this.fetchTracking()
        },
        async fetchTracking() {
            this.loading = true
            this.searched = true
            try {
                let { data } = await axios.get('ow/api/zyl/tracking', {
                    params: {
                        user_id: this.USER_ID,
                        search: this.search
                    }
                })
                if (data.success) {
                    this.outData = data.out_data || null
                    this.trackingData = data.tracking_data || []
                } else {
                    this.outData = null
                    this.trackingData = []
                    let msg = data.message || '查询失败'
                    if (data.errorcode == 1040) {
                        msg = '无匹配数据'
                    } else if (data.errorcode == 1043) {
                        msg = '暂未创建派送单，请联系海外仓客服'
                    }
                    this.$alert(msg, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                }
            } catch (e) {
                this.outData = null
                this.trackingData = []
                this.$alert('查询失败，请稍后重试', '提示', {
                    confirmButtonText: '确定',
                    type: 'error'
                })
            }
            this.loading = false
        },
        getSortedNodes(nodeList) {
            if (!nodeList || !nodeList.length) return []
            // 按时间倒序排列，最新的在前面
            return [...nodeList].sort((a, b) => b.node_time - a.node_time)
        }
    }
}
</script>

<style lang="less" scoped>
.detail-maxbox {
    width: 1300px;
    margin: 0 auto;
    padding-bottom: 40px;
}

/* 搜索区域 */
.search-header {
    margin-top: 20px;
    padding: 20px 0;

    .title-row {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        i {
            font-size: 20px;
            color: #333;
            margin-right: 8px;
        }

        .page-title {
            font-size: 18px;
            color: #333;
            font-weight: 600;
        }
    }

    .search-row {
        display: flex;
        align-items: center;

        .search-input {
            width: 360px;
        }
    }
}

.searchBtn {
    background: #97c641 !important;
    border: none;
    margin-left: 20px !important;
}

/* 收件人信息卡片 */
.info-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 20px 30px;
    margin-bottom: 20px;

    .info-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 60px;

        .info-item {
            display: flex;
            align-items: baseline;

            .info-label {
                min-width: 160px;
                color: #666;
                font-size: 14px;
                font-weight: 600;
            }

            .info-value {
                color: #333;
                font-size: 14px;
            }
        }
    }
}

/* 追踪信息 */
.tracking-section {
    .tracking-card {
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        margin-bottom: 20px;
        overflow: hidden;

        .tracking-header {
            padding: 15px 20px;

            .tracking-title {
                display: flex;
                align-items: center;
                font-size: 16px;
                color: #1890ff;
                font-weight: 600;

                i {
                    margin-right: 8px;
                }

                .tracking-no {
                    margin-left: 15px;
                    font-size: 14px;
                    color: #666;
                    font-weight: 400;
                }

                .status-tag {
                    margin-left: 15px;
                }
            }
        }

        .process-table {
            padding: 0 20px 20px;

            .process-header {
                display: flex;
                align-items: center;
                padding: 10px 0;
                border-bottom: 1px solid #e8e8e8;
                font-size: 14px;
                color: #333;
                font-weight: 600;

                .col-time {
                    width: 200px;
                    flex-shrink: 0;
                }

                .col-desc {
                    flex: 1;
                }

                .col-warehouse {
                    width: 150px;
                    flex-shrink: 0;
                    text-align: left;
                }
            }

            .process-list {
                .process-item {
                    display: flex;
                    align-items: center;
                    padding: 12px 0;
                    border-bottom: 1px dashed #f0f0f0;
                    font-size: 13px;

                    &:last-child {
                        border-bottom: none;
                    }

                    .col-time {
                        width: 200px;
                        flex-shrink: 0;
                        color: #666;
                    }

                    .col-desc {
                        flex: 1;
                        color: #333;

                        .desc-zh {
                            color: #333;
                            font-weight: 500;
                        }

                        .desc-en {
                            margin-left: 4px;
                            color: #666;
                        }

                        .download-icon {
                            margin-left: 8px;
                            color: #1890ff;
                            cursor: pointer;

                            &:hover {
                                color: #40a9ff;
                            }
                        }
                    }

                    .col-warehouse {
                        width: 150px;
                        flex-shrink: 0;
                        text-align: left;
                        color: #666;
                    }
                }
            }
        }
    }
}

/* 空状态 */
.empty-state {
    padding: 60px 0;
    text-align: center;
}
</style>
